/**
 * 환경설정 도메인 라우트 - 시스템 설정 / 업무기준설정.
 * route name = OBJECT_ID -> pages/env.
 */
const routes = [
  {
    // 회사 정보 관리 - 법인 정보 + 사업장 정보 + 회사 직인 (환경설정 > 시스템 설정)
    path: 'env/company',
    name: 'COM0010',
    component: () => import('@/pages/env/COM0010.vue'),
    meta: {
      requiresAuth: true,
      title: '회사 정보 관리',
      menuId: 'COM0010',
      objInfo: 'COM0010 · 환경설정/시스템설정 (미래모델·퍼블리싱)',
    },
  },
  {
    // 로그인 관리 - 로그인 제한 + 2단계 인증 + 비밀번호 설정 (환경설정 > 시스템 설정)
    path: 'env/login',
    name: 'SEC0010',
    component: () => import('@/pages/env/SEC0010.vue'),
    meta: {
      requiresAuth: true,
      title: '로그인 관리',
      menuId: 'SEC0010',
      objInfo: 'SEC0010 · 환경설정/시스템설정 (미래모델·퍼블리싱)',
    },
  },
  {
    // 다국어 관리 - 회사 대표 언어 + 회사 사용 언어 (환경설정 > 시스템 설정)
    path: 'env/i18n',
    name: 'I18N0010',
    component: () => import('@/pages/env/I18N0010.vue'),
    meta: {
      requiresAuth: true,
      title: '다국어 관리',
      menuId: 'I18N0010',
      objInfo: 'I18N0010 · 환경설정/시스템설정 (미래모델·퍼블리싱)',
    },
  },
  {
    // 인사정보 관리 - 사용 설정 + 기준 6탭(조직유형/직무/직책/직위/직급/호봉) (환경설정 > 시스템 설정)
    path: 'env/hr-standards',
    name: 'HRS0010',
    component: () => import('@/pages/env/HRS0010.vue'),
    meta: {
      requiresAuth: true,
      title: '인사정보 관리',
      menuId: 'HRS0010',
      objInfo: 'HRS0010 · 환경설정/시스템설정 (미래모델·퍼블리싱)',
    },
  },
  {
    // 초대 관리 - 제출 항목 관리 + 제출 양식 설정(양식 카드) (환경설정 > 시스템 설정)
    path: 'env/invite',
    name: 'INV0010',
    component: () => import('@/pages/env/INV0010.vue'),
    meta: {
      requiresAuth: true,
      title: '초대 관리',
      menuId: 'INV0010',
      objInfo: 'INV0010 · 환경설정/시스템설정 (미래모델·퍼블리싱)',
    },
  },
  {
    // 권한 관리 - 권한 카드(기본/커스텀) + 풀모달 편집(정보 조회·편집 권한 / 업무 기능별 권한 / 적용 대상)
    path: 'env/authority',
    name: 'AUTH0010',
    component: () => import('@/pages/env/AUTH0010.vue'),
    meta: {
      requiresAuth: true,
      title: '권한 관리',
      menuId: 'AUTH0010',
      objInfo: 'AUTH0010 · 환경설정/시스템설정 (미래모델·퍼블리싱)',
    },
  },
  {
    // 메뉴 관리 - FRM_MENU 트리 CRUD·드래그 + 기능<->메뉴 매핑 (개발자 > 개발자 도구, 운영사 관리자 전용)
    path: 'env/menu',
    name: 'MNU0010',
    component: () => import('@/pages/env/MNU0010.vue'),
    meta: {
      requiresAuth: true,
      title: '메뉴 관리',
      menuId: 'MNU0010',
      objInfo: 'MNU0010 · 개발자/개발자도구 (운영사 관리자 전용)',
    },
  },
  {
    // 권한·메뉴 점검 - 매트릭스 + 권한 요약 + 정합성(읽기전용) (개발자 > 개발자 도구, 운영사 관리자 전용)
    path: 'env/auth-map',
    name: 'AUTH0020',
    component: () => import('@/pages/env/AUTH0020.vue'),
    meta: {
      requiresAuth: true,
      title: '권한·메뉴 점검',
      menuId: 'AUTH0020',
      objInfo: 'AUTH0020 · 개발자/개발자도구 (운영사 관리자 전용·읽기전용)',
    },
  },
  {
    // 결제 관리 - 결제 단위 선택(업무 모듈 토글) [1차], 진행 결제·수단·시뮬레이션 보류 (환경설정 > 시스템 설정)
    path: 'env/payment',
    name: 'PAY0010E',
    component: () => import('@/pages/env/PAY0010E.vue'),
    meta: {
      requiresAuth: true,
      title: '결제 관리',
      menuId: 'PAY0010E',
      objInfo: 'PAY0010E · 환경설정/시스템설정 (미래모델·퍼블리싱)',
    },
  },
  {
    // 회사 휴일 관리 - 국가 캘린더 + 주휴일/휴무일 + 휴일 목록·등록 (환경설정 > 업무기준설정 > 근무기준)
    path: 'env/company-holiday',
    name: 'DTM0060',
    component: () => import('@/pages/env/DTM0060.vue'),
    meta: {
      requiresAuth: true,
      title: '회사 휴일 관리',
      menuId: 'DTM0060',
      objInfo: 'DTM0060 · 환경설정/업무기준설정/근무기준 (미래모델·퍼블리싱)',
    },
  },
  {
    // 출퇴근 체크 방식 설정 - 출퇴근 버튼 / 출입관리 기기 연동 (환경설정 > 업무기준설정 > 근무기준)
    path: 'env/commute-check',
    name: 'DTM0040',
    component: () => import('@/pages/env/DTM0040.vue'),
    meta: {
      requiresAuth: true,
      title: '출퇴근 체크 방식 설정',
      menuId: 'DTM0040',
      objInfo: 'DTM0040 · 환경설정/업무기준설정/근무기준 (미래모델·퍼블리싱)',
    },
  },
  {
    // 교대 근무 기준 관리 - 교대 근무 형태 기준 + 교대 근무조 설정 (환경설정 > 업무기준설정 > 근무기준)
    path: 'env/shift-criteria',
    name: 'DTM0030',
    component: () => import('@/pages/env/DTM0030.vue'),
    meta: {
      requiresAuth: true,
      title: '교대 근무 기준 관리',
      menuId: 'DTM0030',
      objInfo: 'DTM0030 · 환경설정/업무기준설정/근무기준 (미래모델·퍼블리싱)',
    },
  },
  {
    // 근무 그룹 생성 - 근무 그룹 목록 + 근무 대상자 관리 (환경설정 > 업무기준설정 > 근무기준)
    path: 'env/work-group',
    name: 'DTM0020',
    component: () => import('@/pages/env/DTM0020.vue'),
    meta: {
      requiresAuth: true,
      title: '근무 그룹 생성',
      menuId: 'DTM0020',
      objInfo: 'DTM0020 · 환경설정/업무기준설정/근무기준 (미래모델·퍼블리싱)',
    },
  },
  {
    // 근무 세부 코드 - 근무유형·근무구분 설정 (환경설정 > 업무기준설정 > 근무기준)
    path: 'env/work-detail-code',
    name: 'DTM0010',
    component: () => import('@/pages/env/DTM0010.vue'),
    meta: {
      requiresAuth: true,
      title: '근무 세부 코드',
      menuId: 'DTM0010',
      objInfo: 'DTM0010 · 환경설정/업무기준설정/근무기준 (미래모델·퍼블리싱)',
    },
  },
  {
    // 휴가 기준 관리 - 휴가 항목 관리/구분 설정/항목 설정/결재선(*TBD) (환경설정 > 업무기준설정 > 휴가기준)
    path: 'env/leave-criteria',
    name: 'LEV0050',
    component: () => import('@/pages/env/LEV0050.vue'),
    meta: {
      requiresAuth: true,
      title: '휴가 기준 관리',
      menuId: 'LEV0050',
      objInfo: 'LEV0050(가칭) · 환경설정/업무기준설정/휴가기준 (미래모델·퍼블리싱)',
    },
  },
  {
    // 연차 기준 관리 - 연차 지급 방식 설정/연차 사용 촉진 설정 (환경설정 > 업무기준설정 > 휴가기준)
    path: 'env/annual-criteria',
    name: 'LEV0060',
    component: () => import('@/pages/env/LEV0060.vue'),
    meta: {
      requiresAuth: true,
      title: '연차 기준 관리',
      menuId: 'LEV0060',
      objInfo: 'LEV0060(가칭) · 환경설정/업무기준설정/휴가기준 (미래모델·퍼블리싱)',
    },
  },
  {
    // 연동 관리 - placeholder (환경설정 > 시스템 설정)
    path: 'env/link',
    name: 'LNK0010',
    component: () => import('@/pages/env/LNK0010.vue'),
    meta: {
      requiresAuth: true,
      title: '연동 관리',
      menuId: 'LNK0010',
      objInfo: 'LNK0010 · 환경설정/시스템설정 (미진행·준비 중)',
    },
  },
  {
    // 기본 환경 설정 - 본인 화면 설정(언어·컬러테마·글자 크기) (환경설정 > 기본 설정)
    path: 'env/basic',
    name: 'ENV0010',
    component: () => import('@/pages/env/ENV0010.vue'),
    meta: {
      requiresAuth: true,
      title: '기본 환경 설정',
      menuId: 'ENV0010',
      objInfo: 'ENV0010 · 환경설정/기본설정 (개인 언어·테마 · FRM_USER_PREF)',
    },
  },
  {
    // 내 설정 - placeholder (환경설정 > 기본 설정)
    path: 'env/my',
    name: 'MY0010',
    component: () => import('@/pages/env/MY0010.vue'),
    meta: {
      requiresAuth: true,
      title: '내 설정',
      menuId: 'MY0010',
      objInfo: 'MY0010 · 환경설정/기본설정 (준비 중)',
    },
  },
];

export default routes;
